import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=d806e68e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d806e68e')) {
      api.createRecord('d806e68e', component.options)
    } else {
      api.reload('d806e68e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=d806e68e&", function () {
      api.rerender('d806e68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vjqNx6Xa4pAF/JS/comp/ErrorMessage.vue"
export default component.exports